/* import __COLOCATED_TEMPLATE__ from './printable-check.hbs'; */
import Component from '@glimmer/component';
import bbFrontendGlyphIconToSvg from '@banking/ui/utils/bb-frontend-glyph-icon-to-svg';
export default class PrintableCheckActivity extends Component {
  get hasActions() {
    return this.printAction || this.downloadAction || this.cancelAction;
  }
  get printAction() {
    return this.printableCheckId ? this.args.printableCheckManagement.printAction : null;
  }
  get downloadAction() {
    return this.printableCheckId ? this.args.printableCheckManagement.downloadAction : null;
  }
  get cancelAction() {
    return this.args.printableCheckManagement.cancelAction;
  }
  get printIcon() {
    return this.printAction ? bbFrontendGlyphIconToSvg(this.printAction.icon) : '';
  }
  get downloadIcon() {
    return this.downloadAction ? bbFrontendGlyphIconToSvg(this.downloadAction.icon) : '';
  }
  get cancelIcon() {
    return this.cancelAction ? bbFrontendGlyphIconToSvg(this.cancelAction.icon) : '';
  }
  get printableCheckId() {
    const attachment = this.args.attachments?.find(attachment => attachment.checkImage?.checkToken !== null);
    return attachment?.checkImage?.checkToken;
  }
  get showCheckImage() {
    return this.args.attachments?.some(attachment => {
      return attachment.checkImage.image !== null;
    });
  }
}